import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ja',
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  weekdays: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
  weekdaysMin: ['日', '月', '火', '水', '木', '金', '土'],
  weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'Ah:mm',
    lts: 'Ah:mm:ss',
    L: 'YYYY/MM/DD',
    LL: 'YYYY年M月D日',
    'LL-D': 'YYYY年M月',
    'LL-Y': 'M月D日',
    LLL: 'YYYY年M月D日 H:mm',
    'LLL-Y': 'M月D日 H:mm',
    LLLL: 'YYYY年M月D日 (dddd) H:mm',
    'LLLL-Y': 'M月D日 (dddd) H:mm',
    l: 'YYYY/M/D',
    'l-Y': 'M/D',
    ll: 'YYYY年M月D日',
    'll-Y': 'M月D日',
    'll-D': 'YYYY年M月',
    lll: 'YYYY年M月D日 Ah:mm',
    'lll-Y': 'M月D日 Ah:mm',
    llll: 'YYYY年M月D日(ddd) Ah:mm',
    'llll-Y': 'M月D日(ddd) Ah:mm',
    'll-Y+w': 'M月D日(ddd)',
    'LT+to': 'H:mm（[GMT]Z）',
    'LLL+to': 'YYYY年M月D日 H:mm（[GMT]Z）',
  },
  meridiem: { am: '午前', pm: '午後', AM: '午前', PM: '午後' },
  past: {
    y: { other: '%s年前' },
    M: { other: '%sか月前' },
    w: { other: '%s週間前' },
    d: { other: '%s日前' },
    h: { other: '%s時間前' },
    m: { other: '%s分前' },
    s: { other: '%s秒前' },
  },
  future: {
    y: { other: '%s年後' },
    M: { other: '%sか月後' },
    w: { other: '%s週間後' },
    d: { other: '%s日後' },
    h: { other: '%s時間後' },
    m: { other: '%s分後' },
    s: { other: '%s秒後' },
  },
  pastLong: {
    y: { other: '%s年前' },
    M: { other: '%sか月前' },
    w: { other: '%s週間前' },
    d: { other: '%s日前' },
    h: { other: '%s時間前' },
    m: { other: '%s分前' },
    s: { other: '%s秒前' },
  },
  futureLong: {
    y: { other: '%s年後' },
    M: { other: '%sか月後' },
    w: { other: '%s週間後' },
    d: { other: '%s日後' },
    h: { other: '%s時間後' },
    m: { other: '%s分後' },
    s: { other: '%s秒後' },
  },
  abbr: {
    y: { other: '%s年' },
    M: { other: '%sヶ月' },
    w: { other: '%s週間' },
    d: { other: '%s日' },
    h: { other: '%s時間' },
    m: { other: '%s分' },
    s: { other: '%s秒' },
  },
  full: {
    y: { other: '%s年' },
    M: { other: '%sか月' },
    w: { other: '%s週間' },
    d: { other: '%s日' },
    h: { other: '%s時間' },
    m: { other: '%s分' },
    s: { other: '%s秒' },
  },
  justNow: 'たった今',
  yesterday: '昨日',
  today: '今日',
  tomorrow: '明日',
  weekStart: 0,
  timeRange: '%$1s～%$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'Ah:mm': 'H:mm' },
  timeRangeStyles: {
    yl: { start: 'YYYY年M月D日', end: 'YYYY年M月D日' },
    'yl-1': { start: 'YYYY年M月D日', end: 'M月D日' },
    ml: { start: 'M月D日', end: 'M月D日' },
    'ml-1': { start: 'YYYY年M月D日', end: 'D日' },
    dl: { start: 'M月D日', end: 'D日' },
    y: { start: 'YYYY年M月D日', end: 'YYYY年M月D日' },
    'y-1': { start: 'YYYY年M月D日', end: 'M月D日' },
    m: { start: 'M月D日', end: 'M月D日' },
    'm-1': { start: 'YYYY年M月D日', end: 'D日' },
    d: { start: 'M月D日', end: 'D日' },
    Y: { start: 'YYYY年M月D日(ddd)', end: 'YYYY年M月D日(ddd)' },
    'Y-1': { start: 'YYYY年M月D日(ddd)', end: 'M月D日(ddd)' },
    M: { start: 'M月D日(ddd)', end: 'M月D日(ddd)' },
    D: { start: 'M月D日(ddd)', end: 'M月D日(ddd)' },
    yt: { start: 'YYYY年M月D日 H:mm', end: 'YYYY年M月D日 H:mm' },
    mt: { start: 'M月D日 H:mm', end: 'M月D日 H:mm' },
    dt: { start: 'M月D日 H:mm', end: 'M月D日 H:mm' },
    t: { start: 'H時mm分', end: 'H時mm分' },
    'yt+to': { start: 'YYYY年M月D日 H:mm', end: 'YYYY年M月D日 H:mm（[GMT]Z）' },
    'mt+to': { start: 'M月D日 H:mm', end: 'M月D日 H:mm（[GMT]Z）' },
    'dt+to': { start: 'M月D日 H:mm', end: 'M月D日 H:mm（[GMT]Z）' },
    't+to': { start: 'H時mm分', end: 'H時mm分（[GMT]Z）' },
  },
};
const localeName: LocaleName = 'ja';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}日`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? '午前' : '午前';
    } else {
      return isLowerCase ? '午後' : '午後';
    }
  },
};
